import { render, staticRenderFns } from "./ActionLabel.vue?vue&type=template&id=1ae270fa&scoped=true&"
var script = {}
import style0 from "./ActionLabel.scss?vue&type=style&index=0&id=1ae270fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../home/gitlab-runner/.nvm/versions/node/v12.14.1/lib/node_modules/@briskly/vue-cli/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae270fa",
  null
  
)

export default component.exports